import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { City, Zone } from './../models/index';

@Injectable()
export class CityService {
  constructor(private apiCallService: ApiCallService) { }

  getCities(): Promise<City[]> {
    return this.apiCallService.get('/cities');
  }

  ng2SelectItems(cities: City[]): any[] {
    return cities.map((city: City) => {
      return {
        text: city.name,
        children: city.zones.map((zone: Zone) => {
          return {
            id: zone.id,
            text: zone.name
          };
        })
      };
    });
  }

  ngSelectItems(cities: City[]): any[] {
    const array = [];

    cities.forEach(city => {
      city.zones.forEach(zone => {
        array.push({
          id: zone.id,
          name: zone.name,
          city: city.name
        })
      });
    });

    return array;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/city.service.ts